import { Container, Typography, Box, Divider } from "@mui/material";

const Section = ({ title, children }) => (
  <Box sx={{ mb: 4 }}>
    <Typography variant="h6" gutterBottom fontWeight={600}>
      {title}
    </Typography>
    {children}
  </Box>
);

const P = ({ children }) => (
  <Typography variant="body1" paragraph color="text.secondary">
    {children}
  </Typography>
);

export const TermsOfService = () => {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Typography variant="h4" fontWeight={700} gutterBottom>
        Terms of Service
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
        Last updated: May 18, 2026
      </Typography>
      <Divider sx={{ mb: 4 }} />

      <Section title="1. Acceptance of Terms">
        <P>
          By accessing or using our family blog platform ("Service"), you agree to be
          bound by these Terms of Service. If you do not agree to these terms, do not
          use the Service.
        </P>
      </Section>

      <Section title="2. Description of Service">
        <P>
          We provide a private, invite-only platform that allows groups of people — such
          as families — to share posts, photos, and comments with one another. Access is
          granted by a group administrator via a join code or direct invitation.
        </P>
      </Section>

      <Section title="3. Eligibility">
        <P>
          You must be at least 13 years old to use the Service. By using the Service,
          you represent that you meet this requirement. Users under 18 should have
          parental consent.
        </P>
      </Section>

      <Section title="4. Account Responsibility">
        <P>
          Your account is tied to your phone number. You are responsible for maintaining
          the security of your device and any sessions you choose to keep active. Notify
          your group administrator immediately if you believe your account has been
          compromised.
        </P>
      </Section>

      <Section title="5. Acceptable Use">
        <P>You agree not to use the Service to:</P>
        <ul>
          <li><Typography variant="body1" color="text.secondary">Post content that is illegal, abusive, harassing, or defamatory</Typography></li>
          <li><Typography variant="body1" color="text.secondary">Share content that infringes on the intellectual property rights of others</Typography></li>
          <li><Typography variant="body1" color="text.secondary">Upload malicious code, viruses, or other harmful content</Typography></li>
          <li><Typography variant="body1" color="text.secondary">Attempt to gain unauthorized access to the Service or other users' accounts</Typography></li>
          <li><Typography variant="body1" color="text.secondary">Use the Service for commercial purposes without prior written consent</Typography></li>
        </ul>
      </Section>

      <Section title="6. Content Ownership">
        <P>
          You retain ownership of any content you post to the Service. By posting
          content, you grant us a limited, non-exclusive license to store and display
          that content to members of your group for the purpose of operating the Service.
        </P>
        <P>
          You are solely responsible for the content you post. We reserve the right to
          remove content that violates these Terms.
        </P>
      </Section>

      <Section title="7. Subscriptions and Billing">
        <P>
          Access to the Service may require a paid subscription managed by your group
          administrator. Subscription fees are billed per group member per month.
          Groups may be subject to a free trial period, after which continued access
          requires an active subscription. Failure to maintain an active subscription
          may result in suspension of access.
        </P>
        <P>
          All fees are non-refundable except where required by applicable law.
        </P>
      </Section>

      <Section title="8. Termination">
        <P>
          We reserve the right to suspend or terminate access to the Service at our
          discretion, including for violations of these Terms. Group administrators may
          remove members from their group at any time.
        </P>
      </Section>

      <Section title="9. Disclaimer of Warranties">
        <P>
          The Service is provided "as is" without warranties of any kind, either express
          or implied. We do not guarantee uninterrupted or error-free operation of the
          Service.
        </P>
      </Section>

      <Section title="10. Limitation of Liability">
        <P>
          To the fullest extent permitted by law, we shall not be liable for any
          indirect, incidental, special, consequential, or punitive damages arising from
          your use of or inability to use the Service, even if we have been advised of
          the possibility of such damages.
        </P>
      </Section>

      <Section title="11. Changes to These Terms">
        <P>
          We reserve the right to modify these Terms at any time. Group administrators
          will be notified of material changes. Continued use of the Service after
          changes take effect constitutes acceptance of the revised Terms.
        </P>
      </Section>

      <Section title="12. Governing Law">
        <P>
          These Terms shall be governed by and construed in accordance with the laws of
          the State of Idaho, without regard to its conflict of law provisions.
        </P>
      </Section>

      <Section title="13. Contact">
        <P>
          If you have questions about these Terms, please contact your group administrator
          or reach out via the contact information provided when you joined your group.
        </P>
      </Section>
    </Container>
  );
};
